import { createContext } from "react";
import { IRCADashboardContext } from "./RCADashboardContextInterfaces";
import { ApolloQueryResult } from "@apollo/client";

export const initialState: IRCADashboardContext = {
    userActionPlans: [],
    loadingUserActionPlans: false,
    userActionPlansError: undefined,
    refetchUserActionPlans: async () => ({} as ApolloQueryResult<any>),
    userActionPlanFilters: { showCompleted: false },
    setUserActionPlanFilters: () => {},
    orderActionPlans: "asc",
    orderByActionPlans: "",
    pageActionPlans: 0,
    rowsPerPageActionPlans: 5,
    handleRequestSortActionPlans: () => {},
    handleChangeRowsPerPageActionPlans: () => {},
    handleChangePageActionPlans: () => {},
    totalCountActionPlans: 0,
};

export const RCADashboardContext = createContext(initialState);
